<div class="container-fluid padMob webViewBack padZero" style="padding-left: 15px; padding-right: 15px;">
    <div class="row HeadDiv mobView">
        <!-- Header -->
        <div class="col-md-12 col-12 col-sm-12 bgWhite padHeder divHeader" style="padding-bottom: 10px; background-color: #fff;">
            <span style="font-size: 22px; margin-right: 10px; display: inline-block; cursor: pointer;"
                (click)="goBack();"><i class="fa fa-chevron-left"></i></span>
            <h4 style="display: inline-block;">{{prTypeID == 1 ? 'Manufacturing Stages' : 'Project Stages' }}</h4>
            <span style="float: right;">
                <span *ngIf="!enblAddStages" class="label brdrRadius3" (click)="open(mdlStageEntry)"
                    style="cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important;    vertical-align: -webkit-baseline-middle;">
                    <i class="zmdi zmdi-plus"  aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
                <span *ngIf="prTypeID == 2 && enblAddStages" class="label brdrRadius3" (click)="openStageEntryModal(AddStage, 0)"
                    style="cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; background:#e88421 !important; color:#fff !important;    vertical-align: -webkit-baseline-middle;">
                    <i class="zmdi zmdi-plus"  aria-hidden="true" style="font-size: 19px; vertical-align: sub;"></i>
                </span>
                <span
                    style="cursor: pointer; bottom: 5px; padding: 12px; font-size: 11px; display: inline !important; margin-left: 10px; display: none !important;"
                    class="webView closeMdl" (click)="goBack();">
                    <i class="zmdi zmdi-close"></i>
                </span>
            </span>
        </div>

        <div *ngIf="stagesOfProds.length != 0 && !enblAddStages">
            <div style="display: inline-block; width: 100%; border-top: 10px solid #00808008; background: #fff; padding: 10px 10px"
                *ngFor="let s of stagesOfProds">
                <div style="margin-bottom: 3px;">
                    <div style="font-size: 14px; font-weight: bold;">
                        {{s.TStg}}
                        <!-- {{s.FStg}} to {{s.TStg}} -->
                    </div>
                    
                    <div style="color: #777; font-size: 12px;">
                        {{s.Notes}}
                    </div>
                </div>
                <div>
                    <div style="display: inline-flex;">
                        <span class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-left: 0px; margin-bottom: 5px;  font-size: 12px;">
                            <i class="fa fa-calendar"></i> {{s.OnNew}}
                            <i class="fa fa-clock-o" style="margin-left: 5px;"></i> {{s.time}}
                        </span>
                        <span class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" style="margin-left: 8px; margin-bottom: 5px; font-size: 12px;">
                            <i class="fa fa-user"></i> <span style="margin-left: 5px;">{{s.By}}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
        

        <!-- Multiple Consecutive stages -->
        <!-- <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 5px; max-height: 180px;overflow-y: auto;  font-size: 13px; margin-top: 15px; padding: 0px 10px;" *ngIf="prjStages.length > 0 && prTypeID == 2 && enblAddStages">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th style="max-width: 30%;">Stage</th>
                        <th>Started on</th>
                        <th>Due on</th>
                        <th>Started by</th>
                        <th>Ended on</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let s of prjStages" style="cursor: pointer;" (click)="openTaskListModal(s)">
                        <td style="padding-top: 12px !important;">
                            <div style="font-size: 12px; margin-bottom: 0px; vertical-align: inherit;">
                                {{s.SNm}}
                            </div>
                            <div style="color: #777; font-size: 12px;">
                                {{s.IN}}
                            </div>
                        </td>
                        <td style="text-align: left; vertical-align: inherit;">{{s.startDT}}</td>
                        <td style="text-align: left; vertical-align: inherit;">{{s.targetDT}}</td>
                        <td style="text-align: left; vertical-align: inherit;">{{s.by ? s.by : '-'}}</td>
                        <td style="text-align: left; vertical-align: inherit;">{{s.endDT}}</td>
                    </tr>
                </tbody>
            </table>
        </div> -->
        <div *ngIf="prTypeID == 2">
            <div class="col-md-12 col-sm-12 col-12 bgWhite marginTp font13" style="padding: 10px 15px;"
            *ngFor="let s of prjStages" (click)="s.startDT == '-'? openEnterStage(s, $event) : openTaskListModal(s)">
                <div class="col-md-12 col-12 col-sm-12 pad0" style="display: flex;">
                    <div class="col-8 pad0">
                        <div class="col-8 pad0" style="display: flex; gap: 6px; align-items: center;">
                            <span style="font-size: 14px; font-weight: bold; color: #444;">{{s.SNm}}</span>      
                            <div class="lableBtnOrange brdrRadius3" *ngIf="s.startDT != '-'" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.72em;">
                                {{s.startDT == '-' ? '-' : s.tasksCnt}}
                            </div>          
                        </div>
                        <div class="col-4 pad0">
                            <div *ngIf="s.by" style="font-size: 12px; color: grey;">
                                {{s.by}}
                            </div>
                        </div>
                    </div>
                    <div class="col-4 pad0" style="display: flex; justify-content: end; max-height: 30px; align-items: center;">
                        <div class="btn btn-orange brdrRadius3" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.66em;" *ngIf="jobDetails[0].StatusID == 1 && s.startDT == '-'" (click)="openEnterStage(s,$event)"> Start
                        </div>
                        <div class="btn btn-darkGreen brdrRadius3" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.66em;" *ngIf="jobDetails[0].StatusID == 1 && s.startDT != '-' && !s.EDT" (click)="openCNEntryModal(mdlCNEntry,s,$event)">  End 
                        </div>
                        <div *ngIf="s.startDT != '-' && s.EDT">Done</div>
                    </div>
                </div>
                <div class="col-md-12 col-12 col-sm-12 pad0">
                    <span class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite" *ngIf="s.startDT != '-'">Started on: {{s.startDT}}</span>
                    <span class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite">Due on: {{s.targetDT}}</span>
                    <span *ngIf="s.endDT != '-'" class="darkBlueBadge darkBlueBrdr brdrRadius3 bgwhite">Done on: {{s.endDT}}</span>
                </div>
            </div>
        </div>
    </div>

    <div class="row HeadDiv webView">
        <div style="color: darkgreen; font-size: 17px; padding: 10px 10px 0px 10px">
            <span>{{prTypeID == 1 ? 'Production Stages' : 'Project Stages'}}</span>
            <span *ngIf="!enblAddStages" style="float: right; cursor: pointer;" (click)="open(mdlStageEntry)">
                <div class="btn btn-darkGreen brdrRadius3" style="padding: 3px 13px 3px; font-size: 13px; line-height: 1.66em;" *ngIf="jobDetails[0].StatusID == 1">
                    <i class="fa fa-angle-double-right"></i> Move
                </div>
            </span>
            <span *ngIf="prTypeID == 2 && enblAddStages" style="float: right; cursor: pointer;" (click)="openStageEntryModal(AddStage, 0)">
                <div class="btn btn-darkGreen brdrRadius3" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.66em;" *ngIf="jobDetails[0].StatusID == 1">
                    <i class="zmdi zmdi-plus" style="margin-right: 5px;"></i> Add Stage
                </div>
            </span>
        </div>


        <!-- New material consumtion table -->
        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 5px; max-height: 180px;overflow-y: auto;  font-size: 13px; margin-top: 15px; padding: 0px 10px;" *ngIf="stagesOfProds.length != 0 && !enblAddStages">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th style="width: 49%;">Stage</th>
                        <th style="width: 15%; text-align: left;">Date</th>	
                        <th style="width: 15%; text-align: left;">Time</th>
                        <th style="width: 20%; text-align: left;">By</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let s of stagesOfProds" style="cursor: pointer;">
                        <td style="padding-top: 12px !important;" ><div style="font-size: 12px; margin-bottom: 0px; vertical-align: inherit;">
                            {{s.TStg}}
                            <!-- {{s.FStg}} to {{s.TStg}} -->
                        </div>
                        
                        <div style="color: #777; font-size: 12px;">
                            {{s.Notes}}
                        </div>
                    </td>
                        <td style="text-align: left; vertical-align: inherit;">{{s.OnNew}}</td>
                        <td style="text-align: left; vertical-align: inherit;">	
                            {{s.time}}
                        </td>
                        <td style="text-align: left; vertical-align: inherit;">	
                            {{s.By}}
                        </td>        
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- Multiple Consecutive stages -->
        <div class="col-md-12 col-sm-12 col-xs-12" style="padding: 0px 5px; max-height: 200px; overflow-y: auto;  font-size: 13px; margin-top: 15px; margin-bottom: 10px; padding: 0px 10px;" *ngIf="prjStages.length > 0 && prTypeID == 2 && enblAddStages">
            <table class="table table-bordered">
                <thead>
                    <tr>
                        <th style="max-width: 30%; vertical-align: middle;">Stage</th>
                        <th style="vertical-align: middle;">Started on</th>
                        <th style="vertical-align: middle;">Updated by</th>
                        <th style="vertical-align: middle;">Due on</th>
                        <th style="vertical-align: middle;">Done on</th>
                        <th style="width: 6%; vertical-align: middle;"></th>
                        <th style="vertical-align: middle; width: 4%;"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let s of prjStages" (click)="s.startDT == '-'? openEnterStage(s, $event) : openTaskListModal(s)" style="cursor: pointer;">
                        <td style="padding: 7px; vertical-align: middle;">
                            <div style="font-size: 12px; margin-bottom: 0px; vertical-align: middle;">
                                {{s.SNm}}
                            </div>
                            <div style="color: #777; font-size: 12px;" *ngIf="s.IN != ''">
                                {{s.IN}}
                            </div>
                        </td>
                        <td style="text-align: left; vertical-align: inherit;" title="{{s.startDT == '-' ? s.startDT : ('Started on ' + s.startDTFull)}}">{{s.startDT}}</td>
                        <td style="text-align: left; vertical-align: inherit;">{{s.by ? s.by : '-'}}</td>
                        <td style="text-align: left; vertical-align: inherit;">{{s.targetDT}}</td>
                        <td style="text-align: left; vertical-align: inherit;" title="{{s.endDT == '-' ? s.endDT : ('Marked done on ' + s.endDTFull)}}">{{s.endDT}}</td>
                        <td style="text-align: left; vertical-align: inherit; text-align: center;">
                            <div class="btn btn-orange brdrRadius3" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.66em;" *ngIf="jobDetails[0].StatusID == 1 && s.startDT == '-'" (click)="openEnterStage(s,$event)"> Start
                            </div>
                            <div class="btn btn-darkGreen brdrRadius3" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.66em;" *ngIf="jobDetails[0].StatusID == 1 && s.startDT != '-' && !s.EDT" (click)="openCNEntryModal(mdlCNEntry,s,$event)">  End 
                            </div>
                            <div *ngIf="s.startDT != '-' && s.EDT">Done</div>
                            <!-- <div class="btn btn-orange brdrRadius3" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.66em;" *ngIf="jobDetails[0].StatusID == 1 && s.startDT != '-'">
                                Done
                            </div> -->
                        </td>
                        <td style="text-align: left; vertical-align: inherit; text-align: center;">
                            <div class="lableBtnOrange brdrRadius3" style="padding: 3px 8px 3px; font-size: 14px; line-height: 1.72em;">
                                {{s.startDT == '-' ? '-' : s.tasksCnt}}
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- d-none -->
        <div class="col-md-12 col-12 col-sm-12" style="padding: 0px; display: none;">
            <div style="height: 226px; overflow-y: auto; width: 99%;">
                <div style="display: inline-block; width: 100%; vertical-align: middle; border-top: 10px solid #00808008; background: #fff; padding: 5px 10px"
                    *ngFor="let s of stagesOfProds" (click)="openTaskListModal(s)">
                    <div style="display: inline-block; width: 29%; vertical-align: middle;">
                        <div style="font-size: 12px; margin-bottom: 0px;">
                            {{s.TStg}}
                            <!-- {{s.FStg}} to {{s.TStg}} -->
                        </div>
                        
                        <div style="color: #777; font-size: 12px;">
                            {{s.Notes}}
                        </div>
                    </div>
                    <div style="display: inline-block; width: 71%; text-align: end;vertical-align: middle;">
                        <div style="display: inline-flex;">
                            <span class="yellowBadge" style="margin-left: 0px;  font-size: 12px;">
                                <i class="fa fa-calendar"></i> {{s.OnNew}}
                                <i class="fa fa-clock-o" style="margin-left: 5px;"></i> {{s.time}}
                            </span>
                            <span class="greenBadge" style="margin-left: 5px; font-size: 12px;">
                                <i class="zmdi zmdi-account"></i> <span style="margin-left: 5px;">{{s.By}}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>

        </div>

        <div *ngIf="stagesOfProds.length == 0 && !enblAddStages">
            <div class="nrf brdrRadius3" (click)="open(mdlStageEntry);" style="margin: 15px 0px; margin-left: 6px; cursor: pointer;font-size: 13px;">
                <!-- Click here to add a stage to your process flow. -->
                {{prTypeID == 1 ? 'Click here to move the production job.': 'Click here to move the project.'}}
            </div>
        </div>
        <div *ngIf="prjStages.length == 0 && enblAddStages">
            <div class="nrf brdrRadius3" (click)="openEnterStage()" style="margin: 15px 0px; margin-left: 6px; cursor: pointer;font-size: 13px;">
                <!-- Click here to add a stage to your process flow. -->
                Click here to add the stage.
            </div>
        </div>
    </div>
</div>

<div style="display: none;" id="moveJobBtn" (click)="open(mdlStageEntry)"></div>

<!-- Stage Entry Level Modal -->
<ng-template #mdlStageEntry let-modal>
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr">{{prTypeID == 1 ? 'Move Job' : 'Update Project Stage'}}</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>

    <!--Body-->
    <div class="modal-body" style="padding: 0px; padding-bottom: 15px;">
        <div>
            <div class="col-md-12 col-12 col-sm-12" style="margin-top: 12px;">
                <span style="font-size: 13px; cursor: pointer;">
                    From :
                </span>
                <span class="orangeBadge brdrRadius3 bgwhite" style="margin-left: 20px;cursor: pointer; font-size: 13px; border: 1px solid #e88421; line-height: 14px; ">
                    {{jobDetails[0].Stage ? jobDetails[0].Stage : 'Unstarted'}}
                </span>
                <br>

                <span style="position: relative; top: 10px; cursor: pointer;">
                    <span style="font-size: 13px;">
                        To     :
                    </span>

                    <span class="mobWht" style="display: inline-flex;margin-left: 38px;width: 30%;">
                        <!-- <input class="form-control" list="stageList" placeholder="Select Stage" [(ngModel)]="newstage"
                            style="width: 435px;" (blur)="blurStage()">
                        <datalist id="stageList">
                            <option *ngFor="let s of stageList;" [value]="s.SNm">{{s.SNm}}</option>
                        </datalist> -->
                      
                        <select class="form-control formCtlFltr " style="background-color: inherit; cursor: pointer;" [(ngModel)]="newstage" (ngModelChange)="blurStage()">
                            <option value="" selected>Select</option>
                            <option *ngFor="let s of stageList" [ngValue]="s.SNm">{{s.SNm}}</option> 
                        </select>
                    </span>
                </span>
            </div>

            <div class="col-md-12 col-12 col-sm-12"  *ngIf="prTypeID == 1 && newstage.length > 1" style="padding: 0px;">
                <h5 style="color: rgb(5, 5, 5); margin-top: 30px; margin-bottom: 0px; margin-left: 15px; font-size: 17px;">Rejection</h5>
                <div style="min-height: 90px; max-height: 270px; overflow: auto;">
                    <div style="display: inline-block; width: 100%; background: #9eb6be26; padding: 10px 15px; margin-top: 10px;"
                        *ngFor="let p of JobProducts">
                        <div style="display: inline-block; width: 60%;">
                            <span style="font-size: 13px;">
                                {{p.ItemName}}
                            </span>
                            <br>
                            <span class="mobWht65" style="display: inline-flex; width: 50%;font-size: 13px;">
                                <!-- <input class="form-control" list="rsnList" [(ngModel)]="p.Rsn"
                                    placeholder="Select Reason"
                                    style="width: 100%;display: inline-block;  background: inherit;">
                                <datalist id="rsnList">
                                    <option *ngFor="let R of Reasons;" [value]="R.Rsn">{{R.Rsn}}</option>
                                </datalist> -->
                                <select class="label Bluebadge form-control" style="background-color: inherit; cursor: pointer; color: #777" [(ngModel)]="p.Rsn">
                                    <option value="" selected>Select</option>
                                    <option *ngFor="let R of Reasons" [ngValue]="R.Rsn">{{R.Rsn}}</option> 
                                </select>
                            </span>
                        </div>
                        <div style="display: inline-block;width: 39%;text-align: end;vertical-align: top;margin-top: 20px;">
                            <span style="font-size: 12px;">
                                <input type="text" id="txtItem"  [(ngModel)]="p.RjctQty" class="form-control"
                                    tabindex="1" placeholder="Qty" style="height: 20px; padding: 15px; width: 80px; cursor: pointer; display: inline-block; background: inherit; text-align: right;"
                                    maxlength="5" />
                            </span>
                            <span style="font-size: 12px;">
                                {{p.SKU}}
                            </span>
                            <br>
                            <span style="font-size: 13px; color: #777;">
                                Rej : {{p.RejQty}} {{p.SKU}}
                            </span>
                        </div>
                    </div>
                </div>

            </div>

            <div class="col-md-12 col-12 col-sm-12" style="margin-top: 20px;">
                <textarea rows="3"  maxlength="200" [(ngModel)]="notes"  class="txtArea fn13 brdrRadius3" placeholder="Notes" style="border-color: #BCC2C9; font-size: 13px; resize: none; margin-top: 10px; width: 100% ;"></textarea>
                
                <!-- <mat-form-field out class="example-full-width myText" appearance="outline"
                style="width: 100%; padding-bottom: 10px;">
                    <mat-label style="font-size: 13px;">Note</mat-label>
                    <textarea matInput rows="2" style="resize: none;" [(ngModel)]="notes" maxlength="200"
                    tabindex="1"></textarea>
                </mat-form-field> -->
            </div>

            <div class="col-md-12 col-12 col-sm-12" style="margin-top: 10px;">
                <div class="btn btn-save brdrRadius3" (click)="MoveJob();"
                    style="padding: 3px 13px 3px; font-size: 13px; line-height: 1.66em;">
                    <i class="fa fa-angle-double-right"></i> Move
                </div>
            </div>
        </div>
    </div>
</ng-template>

<!--Add stage-->
<ng-template #AddStage let-modal>
    <!--Header-->
    <div class="modal-header" style="border-bottom: none; padding-bottom: 5px !important;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr" style="font-size: 22px;">Add Stage</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close " title="Close" style="float: right;" (click)="closeModal()"></i>
                </div>
            </div>
        </div>
    </div>
    <!--Body-->
    <div class="modal-body" style="padding: 0px;">
        <div class="col-md-12">
            <div style="display: flex; flex-wrap: wrap; justify-content: space-between;">
                <div class="col-md-6 col-12 col-sm-12 pad0">
                    <span style="font-size: 13px;">
                        Stage
                    </span>
                    <div>
                        <input type="text" class="form-control brdrColor brdrRadius3" [(ngModel)]="newStage.stageName" maxlength="50"
                        style="cursor: pointer; margin-top: 5px; border: 1px solid #BCC2C9;" placeholder="Enter Stage" tabindex="1" captalize-first>                      
                    </div>
                </div>
                <div class="col-md-5 col-12 col-sm-12 pad0 marginTop10Mob">
                    <span style="font-size: 13px;">
                        Target
                    </span>
                    <div style="display: flex;">
                        <input readonly (click)="picker.open()" (focus)="picker.open()" [matDatepicker]="picker" [min]="todayDate" class="form-control brdrColor brdrRadius3" tabindex="2" [(ngModel)]="newStage.TDT" style="display: inline-block; outline: none !important; cursor: pointer; font-size: 13px; margin-top: 5px; padding-left: 6px; font-size: 12px; border: 1px solid #BCC2C9;">
                        <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                    </div>  
                </div>
            </div>
            <div class="col-md-12 col-12 col-sm-12 pad0" style="margin-top: 10px;">
                <span style="font-size: 13px;">
                    Instructions
                </span>
                <textarea rows="3" tabindex="3"  maxlength="200" [(ngModel)]="newStage.instruction" class="form-control brdrColor brdrRadius3" style="font-size: 13px; resize: none; margin-top: 5px; width: 100%; outline: none; padding: 4px 8px; font-size: 12px; border: 1px solid #BCC2C9;" placeholder="Enter Instructions"></textarea>
            </div>
            
        </div>
        <div class="col-md-12 col-xs-12 col-12" style="display: inline-block; padding: 5px 0px 15px 15px; margin-top: 10px;">
            <span class="btn-darkGreen brdrRadius3" style="padding: 0px 10px; font-size: 14px; line-height: 30px;" (click)="addStage(newStage,'')">
                <i class="zmdi zmdi-check" style="margin-right: 5px;"></i>
                <span>Save</span>
            </span>
        </div>
    </div>
</ng-template>

<!-- Conclusion Notes Entry Modal -->
<ng-template #mdlCNEntry let-modal>
    <div class="modal-header" style="border-bottom: none;">
        <div class="col-md-12 col-12 col-xs-12">
            <div class="row">
                <div class="col-md-9 col-10 col-xs-10" style="padding-left: 0px;">
                    <h4 class="modal-title">
                        <span id="ApntmntHdr">Enter Conclusion Notes</span>
                    </h4>
                </div>
                <div class="col-md-3 col-2 col-xs-2" style="padding: 0px;">
                    <i class="closeMdl zmdi zmdi-close" style="float: right;" (click)="closeCNEntryModal()"></i>
                </div>
            </div>
        </div>
    </div>

    <!--Body-->
    <div class="modal-body" style="padding-bottom: 15px; padding-top: 0px;">
        <div>
            <span class="orangeBadge brdrRadius3 bgwhite orangeBrdr" style="margin-right: 5px; margin-bottom: 5px; font-size: 12px; padding: 4px 10px;">
                Stage: <span style="font-size: 12px; font-weight: 600;">
                    {{selStageData.SNm}}
                </span>
            </span>
        </div>
        <div>
            <textarea class="form-control brdrColor" rows="2" [(ngModel)]="selStageData.CN"  style="padding: 7px;font-size: 12px !important; resize: none; margin-top:10px; border:1px solid #ddd;border-radius:3px !important;width: 100%;" maxlength="200"
                placeholder="Stage Conclusion Notes" tabindex="1">
            </textarea>
        </div>
    </div>
    <!-- WebView Footer -->
    <div class="modal-footer" style="border: none; text-align: left; float: left; justify-content: left !important; padding: 0px 15px 20px;">
        <span class="btn btn-darkGreen brdrRadius3" (click)="markStageDone()" style="font-size: 13px; padding: 2px 7px 2px; line-height: 1.66em;">
            <i class="fa fa-check" style="margin-right: 5px;"></i>
            <span>Save</span>
        </span>
    </div>
</ng-template>
